import { SlideHeader, Headline, Body, StepList, SiteLink } from "../shared";

export function Slide09Clinical() {
  const STEPS = [
    { title: "Physician Recommendation", desc: "A dermatologist or medical aesthetics provider recommends a personalized post-treatment or daily routine." },
    { title: "Personalized Guidance", desc: "The regimen reflects the patient's specific treatment, skin type and goals." },
    { title: "Immediate Access", desc: "WearSpray's wearable dispenser keeps the recommended formulation on the wrist, not in a bag or left at home." },
    { title: "Consistent Application", desc: "Access removes one barrier to actually following through, day after day." },
  ];
  return (
    <div className="max-w-5xl" data-testid="pitch-slide-clinical">
      <SlideHeader n="09" label="Clinical & Adherence" />
      <div className="grid lg:grid-cols-2 gap-x-12 gap-y-6 items-start">
        <div>
          <Headline>
            The missing link between personalized skincare and{" "}
            <span className="text-accent">patient adherence.</span>
          </Headline>
          <Body>
            Dermatologists and medical aesthetics partners invest heavily in personalized
            formulations and post-treatment recommendations. The piece still missing: whether
            patients keep using what's recommended once they leave the office.
          </Body>
          <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-5 max-w-2xl">
            An evaluation concept, not a completed study. Clinical benefit remains to be validated.
          </p>
          <SiteLink href="https://wearspray.com/clinical">See the Clinical &amp; Adherence opportunity on wearspray.com</SiteLink>
        </div>
        <StepList testid="pitch-clinical-steps" steps={STEPS} />
      </div>
    </div>
  );
}
